/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebu_Stl_StlInputs */

const en_ebu_stl_stl = /** @type {(inputs: Ebu_Stl_StlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EBU STL (.stl)`)
};

const fr_ebu_stl_stl = /** @type {(inputs: Ebu_Stl_StlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EBU STL (.stl)`)
};

const de_ebu_stl_stl = /** @type {(inputs: Ebu_Stl_StlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EBU STL (.stl)`)
};

const it_ebu_stl_stl = /** @type {(inputs: Ebu_Stl_StlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EBU STL (.stl)`)
};

const ru_ebu_stl_stl = /** @type {(inputs: Ebu_Stl_StlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EBU STL (.stl)`)
};

const es_ebu_stl_stl = /** @type {(inputs: Ebu_Stl_StlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo STL de la UER (.stl)`)
};

const zh_cn2_ebu_stl_stl = /** @type {(inputs: Ebu_Stl_StlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EBU STL (.stl)`)
};

const ja_ebu_stl_stl = /** @type {(inputs: Ebu_Stl_StlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EBU STL (.stl)`)
};

const hi_ebu_stl_stl = /** @type {(inputs: Ebu_Stl_StlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईबीयू एसटीएल (.stl)`)
};

const pt_pt2_ebu_stl_stl = /** @type {(inputs: Ebu_Stl_StlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EBU STL (.stl)`)
};

/**
* | output |
* | --- |
* | "EBU STL (.stl)" |
*
* @param {Ebu_Stl_StlInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ebu_stl_stl = /** @type {((inputs?: Ebu_Stl_StlInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebu_Stl_StlInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ebu_stl_stl(inputs)
	if (locale === "de") return de_ebu_stl_stl(inputs)
	if (locale === "it") return it_ebu_stl_stl(inputs)
	if (locale === "ru") return ru_ebu_stl_stl(inputs)
	if (locale === "es") return es_ebu_stl_stl(inputs)
	if (locale === "zh-CN") return zh_cn2_ebu_stl_stl(inputs)
	if (locale === "ja") return ja_ebu_stl_stl(inputs)
	if (locale === "hi") return hi_ebu_stl_stl(inputs)
	if (locale === "pt-PT") return pt_pt2_ebu_stl_stl(inputs)
	return en_ebu_stl_stl(inputs)
});